<app-common-header></app-common-header>
<div class="webview">
  <main role="main" class="maincnt quest">
    <div
      class="getbannersect  pb-2 pl-0 pr-0 chartScroll" style="padding-top: 5px;"
      id="scrollposition"
    >
      <div class="col-sm-12 p-0 ml-4" style="display: none;">
        <a
          href="javascript:void(0)"
          class="backbtn webview"
          (click)="back()"
        ></a>
      </div>
      <div class="col-12 text-center webview">
        <!-- <img
          src="assets/images/eva-icons.svg"
          class="signimg signimgg"
          width="100"
        /> -->
      </div>
      <div class="container">
        <div class="col-sm-12 p-0 mt-3" id="content">
          <!-- <h1 class="headtxt headpadd mbpadt">
            We compared
            <span class="txtclr font-weight-semibold-calibre isEnabled"
              >{{ providersCount }} electricity providers</span
            >
            and
            <a
              id="getAllPlans"
              href="javascript:void(0);"
              class="txtclr font-weight-semibold-calibre isEnabled"
              (click)="getAllPlanDetails()"
            >
              {{
                recommendations != undefined
                  ? recommendations.length
                  : recommendationObj.res_products_recommendations.length
              }}
              plans</a
            >
            and ranked them according to your lifestyle, household and budget.
          </h1> -->
          <h1 class="headtxt headpadd mbpadt">
            Unbeatable savings! Lock in your plan now before rates change. <br/> These exclusive deals won’t last!

          </h1>
          <h1 class="text-left searchtxt m-auto col-lg-9 p-0" style="display: none;font-size: 19px !important;">
            <!-- All pricing shown includes all fees, discounts and
            {{ getUtilityNameFromQuestionnaire() }} delivery charges. There are
            no hidden fees. -->
            To find potential savings and see how much Honest Gorilla could help you save, check the section on your bill where it states, <strong><i>“The average price you paid for electric service this month (per kWh)” and compare.</i></strong>
            <br />
            <br />
          
          
          </h1>
        </div>
       
      </div>
      <div class="container p-0">
        <div style="border-radius: 6px;margin-left: -15px;background-color: grey !important; color: #fff; padding: 7px;text-align: center;">
          <h1 class="searchtxt m-auto p-0" style="font-size: 19px !important;">⚡No hidden fees — our rates cover all monthly electric provider and utility charges, except taxes.

            <i  data-html="true" data-toggle="tooltip" title="To find potential savings and see how much Honest Gorilla could help you save, check the section on your bill where it states, <strong><i>“The average price you paid for electric service this month (per kWh)” and compare.</i></strong>"         class="fa fa-question-circle ml-1"style="
                          vertical-align: bottom !important;
                          cursor: pointer !important;
                          line-height:1.1
                        "></i>

          </h1>
         
        </div>
        <div class="row">
          
          <div class="col-2">
            <div class="sideBarDiv">
              <h4 style="font-size: 16px;margin-top:8px;text-align: center">Refine Selection Criteria</h4>
              <h6 style="font-size: 16px;margin-top:8px;text-align: center;line-height: 0;
              margin-bottom: 20px;">(Select desired filters)</h6>
              <div class="row"  style="background: #F0F0F0;border-radius: 6px;height: fit-content;padding-bottom: 15px;border:1px solid #E2E2E2">

                <div  class="col-md-12 px-2">
                  <h4  data-toggle="collapse" href="#multiCollapseExample1" aria-expanded="true" aria-controls="multiCollapseExample1" style="font-size: 16px;margin-top:8px;text-align: center;cursor: pointer;">Average Monthly Usage
                  </h4>
                  <div class="collapse multi-collapse show" id="multiCollapseExample1">
                    <div style="background: #fff; border-radius: 6px;border:1px solid #E2E2E2">
                      <div
                        *ngFor="let avgUsage of loadAvgUsages; let i = index"
                        class="d-flex align-items-center"
                      >
                        <div
                          class="custom-control custom-checkbox display-block cus-chk chkbox ml-2 my-0 mb-0"
                          style="margin-bottom: 0px !important"
                        >
                          <input
                            type="checkbox"
                            class="pdfclr custom-control-input"
                            style="margin-right: 7px"
                            id="{{ avgUsage.value }}"
                            (click)="selectAvgChange($event, avgUsage.value)"
                            #avgUsageMob="ngModel"
                            [(ngModel)]="avgUsage.checked"
                            name="{{ avgUsage.value }}"
                            value="{{ avgUsage.value }}"
                          />
    
                          <label
                            [ngClass]="{'pink-fontcolor' : avgUsage.checked }"
                            for="{{ avgUsage.value }}"
                            style="font-size: 16px; margin-bottom: 0px;cursor: pointer;"
                            class="custom-control-label mt-1"
                          >
                            <strong>{{ avgUsage.title }}</strong></label>
                            <p 
                            [ngClass]="{'pink-fontcolor' : avgUsage.checked }"
                            style="
                              font-size: 16px;
                              margin-left: 16px;
                              margin-top: 0px;
                              margin-bottom: 0px;
                              line-height: 0.5;
                              cursor: pointer;
                          ">{{ ShowUpdatedUsage ? avgUsage.des.replace('_____', recommendProduct != undefined ?  math.round(recommendProduct.new_tier.ave_monthly_usage) : '') :  avgUsage.des }}</p>
                        
                        </div>
                      </div>
                      <br />
                    </div>
                    <div *ngIf="showOption === true" class="editgraph pb-0" style="background: #fff; border-radius: 6px">
                    <ng-container
                      *ngFor="let monthObj of monthlyUsageArr; let j = index"
                    >
                      <div class="col-6 monthvice col-sm-6">
                        <label
                          *ngIf="monthObj.month === 'January'"
                          class="col-12 p-0 monthlabel"
                          [class.active]="monthactive === 'Januarytrue'"
                          [ngStyle]="{
                            'font-family':
                              monthactive === 'Januarytrue'
                                ? 'Calibre-SemiBold'
                                : 'Calibre'
                          }"
                          >Jan</label
                        >
                        <label
                          *ngIf="monthObj.month === 'February'"
                          class="col-12 p-0 monthlabel"
                          [class.active]="monthactive === 'Februarytrue'"
                          [ngStyle]="{
                            'font-family':
                              monthactive === 'Februarytrue'
                                ? 'Calibre-SemiBold'
                                : 'Calibre'
                          }"
                          >Feb</label
                        >
                        <label
                          *ngIf="monthObj.month === 'March'"
                          class="col-12 p-0 monthlabel"
                          [class.active]="monthactive === 'Marchtrue'"
                          [ngStyle]="{
                            'font-family':
                              monthactive === 'Marchtrue'
                                ? 'Calibre-SemiBold'
                                : 'Calibre'
                          }"
                          >Mar</label
                        >
                        <label
                          *ngIf="monthObj.month === 'April'"
                          class="col-12 p-0 monthlabel"
                          [class.active]="monthactive === 'Apriltrue'"
                          [ngStyle]="{
                            'font-family':
                              monthactive === 'Apriltrue'
                                ? 'Calibre-SemiBold'
                                : 'Calibre'
                          }"
                          >Apr</label
                        >
                        <label
                          *ngIf="monthObj.month === 'May'"
                          class="col-12 p-0 monthlabel"
                          [class.active]="monthactive === 'Maytrue'"
                          [ngStyle]="{
                            'font-family':
                              monthactive === 'Maytrue'
                                ? 'Calibre-SemiBold'
                                : 'Calibre'
                          }"
                          >May</label
                        >
                        <label
                          *ngIf="monthObj.month === 'June'"
                          class="col-12 p-0 monthlabel"
                          [class.active]="monthactive === 'Junetrue'"
                          [ngStyle]="{
                            'font-family':
                              monthactive === 'Junetrue'
                                ? 'Calibre-SemiBold'
                                : 'Calibre'
                          }"
                          >Jun</label
                        >
                        <label
                          *ngIf="monthObj.month === 'July'"
                          class="col-12 p-0 monthlabel"
                          [class.active]="monthactive === 'Julytrue'"
                          [ngStyle]="{
                            'font-family':
                              monthactive === 'Julytrue'
                                ? 'Calibre-SemiBold'
                                : 'Calibre'
                          }"
                          >Jul</label
                        >
                        <label
                          *ngIf="monthObj.month === 'August'"
                          class="col-12 p-0 monthlabel"
                          [class.active]="monthactive === 'Augusttrue'"
                          [ngStyle]="{
                            'font-family':
                              monthactive === 'Augusttrue'
                                ? 'Calibre-SemiBold'
                                : 'Calibre'
                          }"
                          >Aug</label
                        >
                        <label
                          *ngIf="monthObj.month === 'September'"
                          class="col-12 p-0 monthlabel"
                          [class.active]="monthactive === 'Septembertrue'"
                          [ngStyle]="{
                            'font-family':
                              monthactive === 'Septembertrue'
                                ? 'Calibre-SemiBold'
                                : 'Calibre'
                          }"
                          >Sep</label
                        >
                        <label
                          *ngIf="monthObj.month === 'October'"
                          class="col-12 p-0 monthlabel"
                          [class.active]="monthactive === 'Octobertrue'"
                          [ngStyle]="{
                            'font-family':
                              monthactive === 'Octobertrue'
                                ? 'Calibre-SemiBold'
                                : 'Calibre'
                          }"
                          >Oct</label
                        >
                        <label
                          *ngIf="monthObj.month === 'November'"
                          class="col-12 p-0 monthlabel"
                          [class.active]="monthactive === 'Novembertrue'"
                          [ngStyle]="{
                            'font-family':
                              monthactive === 'Novembertrue'
                                ? 'Calibre-SemiBold'
                                : 'Calibre'
                          }"
                          >Nov</label
                        >
                        <label
                          *ngIf="monthObj.month === 'December'"
                          class="col-12 p-0 monthlabel"
                          [class.active]="monthactive === 'Decembertrue'"
                          [ngStyle]="{
                            'font-family':
                              monthactive === 'Decembertrue'
                                ? 'Calibre-SemiBold'
                                : 'Calibre'
                          }"
                          >Dec</label
                        >

                        <input
                          type="number"
                          (click)="monthvalueclick(monthObj)"
                          class="valueinput"
                          (keyup)="onKey($event, j)"
                          pattern="\d*"
                          value="{{ monthObj.usage }}"
                          autofocus
                        />
                        <font>kWh</font>
                      </div>
                    </ng-container>
                    <div class="col-12 px-0 d-flex updatebtn flot-left text-left">
                      <!-- <button
                        [disabled]="!showUndo"
                        [ngClass]="{ disabledButton: !showUndo }"
                        class="btn signup font15 font-weight-bold-calibre sectbtnhvr mbsign update-signup mr-3 mb-2 ml-1"
                        (click)="resetEditValue('undo')"
                      >
                        RESET
                      </button> -->
                      <button
                      class="btn signup font15 font-weight-bold-calibre sectbtnhvr mbsign update-signup mr-3 mb-2 ml-1"
                      (click)="resetEditValue('undo')"
                    >
                      RESET
                    </button>
                      <button
                        class="btn signup font15 font-weight-bold-calibre sectbtnhvr mbsign updatebtn update-signup mb-2"
                        (click)="updategraph(true);"
                      >
                        UPDATE</button
                      ><br />
                    </div>
                  </div>
                </div>
                </div>
                <div class="col-md-12 px-2">
                  <h4 data-toggle="collapse" href="#multiCollapseExample2" aria-expanded="false" aria-controls="multiCollapseExample2" style="font-size: 16px;margin-top:8px;text-align: center;cursor: pointer;">Product Type</h4>
                  <h6 data-toggle="collapse" href="#multiCollapseExample2" aria-expanded="false" aria-controls="multiCollapseExample2" style="font-size: 16px;margin-top:8px;text-align: center;line-height: 0;cursor: pointer;
                  margin-bottom: 20px;">(Select all that apply)</h6>

                  <div class="collapse multi-collapse" id="multiCollapseExample2" style="background: #fff; border-radius: 6px;border:1px solid #E2E2E2">
                    <div
                      *ngFor="
                        let productTypes of loadProductTypes;
                        let i = index
                      "
                      class="d-flex align-items-center"
                    >
                      <div
                        class="custom-control custom-checkbox display-block cus-chk l-2 my-0 mb-0"
                        style="margin-bottom: 0px !important"
                      >
                        <input 
                          type="checkbox"
                          class="pdfclr custom-control-input"
                          style="margin-right: 7px;display: none;"
                          id="{{ productTypes.value }}"
                          (click)="productchange($event, productTypes.value)"
                          #productTypesMob="ngModel"
                          [(ngModel)]="productTypes.checked"
                          name="{{ productTypes.value }}"
                          value="{{ productTypes.value }}"
                        />
                        <img *ngIf="!productTypes.checked"
                            src="assets/images/toggle-off.svg"
                            class="pl-2"
                            style="
                              font-size: 16px !important;
                              cursor: pointer;
                              vertical-align: middle;
                              width: 28px !important; height: 15px !important;margin-right: 8px;
                            "
                            aria-hidden="true"
                            (click)="productchange($event, productTypes.value)"
                          />
                          <img *ngIf="productTypes.checked"
                          src="assets/images/toggle-on.svg"
                          class="pl-2"
                          style="
                            font-size: 16px !important;
                            cursor: pointer;
                            vertical-align: middle;
                            width: 28px !important; height: 15px !important;margin-right: 8px;
                          "
                          (click)="productchange($event, productTypes.value)"
                          aria-hidden="true"
                          
                        />


                        <label
                        [ngClass]="{'pink-fontcolor' : productTypes.checked }"
                          for="{{ productTypes.value }}"
                          style="font-size: 16px; margin-bottom: 0px;cursor: pointer;"
                          class="custom-control-label mt-1 productType-ch"
                          >{{ productTypes.key }}</label
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-12 px-2">
                  <h4 data-toggle="collapse" href="#multiCollapseExample3" aria-expanded="false" aria-controls="multiCollapseExample3"  style="font-size: 16px;margin-top:8px;text-align: center;cursor: pointer;">Contract Length</h4>
                  <h6 data-toggle="collapse" href="#multiCollapseExample3" aria-expanded="true" aria-controls="multiCollapseExample3" style="font-size: 16px;margin-top:8px;text-align: center;line-height: 0;cursor: pointer;
                  margin-bottom: 20px;">(Select all that apply)</h6>
                  <div class="collapse multi-collapse" id="multiCollapseExample3" style="background: #fff; border-radius: 6px;border:1px solid #E2E2E2">
                    <div
                      class="row no-gutters"
                      *ngFor="let term of dropDownValues; let i = index"
                    >
                      <div>
                        <div class="d-flex align-items-center">
                          <div
                            class="custom-control custom-checkbox chkbox ml-2 my-0 mb-0"
                            style="margin-bottom: 0px !important"
                          >
                            <input
                              type="checkbox"
                              class="pdfclr custom-control-input chk-border"
                              style="margin-right: 7px"
                              id="contractTermwb{{ i + 1 }}"
                              name="example{{ i + 1 }}"
                              #terms="ngModel"
                              value="{{ term.value }}"
                              [(ngModel)]="term.checked"
                              (click)="selectthis($event, i + 1, 'Webview')"
                            />

                            <label
                              for="contractTermwb{{ i + 1 }}"
                              *ngIf="term.value !== '1000'"
                              style="font-size: 16px; margin-bottom: 0;cursor: pointer;"
                              class="custom-control-label mt-1"
                            >
                              {{ term.value }} {{term.value == 1 ? "month" : "months"}}
                            </label>
                            <label
                              for="contractTermwb{{ i + 1 }}"
                              *ngIf="term.value === '1000'"
                              style="font-size: 16px; margin-bottom: 0;cursor: pointer;"
                              class="custom-control-label mt-1"
                            >
                              Show All
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-12 px-2">
                  <h4 data-toggle="collapse" href="#multiCollapseExample4" aria-expanded="false" aria-controls="multiCollapseExample4"  style="font-size: 16px;margin-top:8px;text-align: center;cursor: pointer;">Energy Providers</h4>
                  <h6 data-toggle="collapse" href="#multiCollapseExample4" aria-expanded="false" aria-controls="multiCollapseExample4" style="font-size: 16px;margin-top:8px;text-align: center;line-height: 0;cursor: pointer;
                  margin-bottom: 20px;">(Select all that apply)</h6>
                  <div class="collapse multi-collapse" id="multiCollapseExample4" style="background: #fff; border-radius: 6px;border:1px solid #E2E2E2">
                    <div
                      class="row no-gutters"
                      *ngFor="
                        let energyObjMob of energyProviderList;
                        let i = index
                      "
                    >
                      <div>
                        <div
                          class="custom-control custom-checkbox chkbox ml-2 my-0 mb-0"
                          style="margin-bottom: 0px !important"
                        >
                          <input
                            type="checkbox"
                            class="pdfclr custom-control-input  {{ energyObjMob.value == 'Show All' ? 'ShowAllProviderClass' : ''}}"
                            style="margin-right: 7px"
                            id="energyObj{{ i + 1 }}"
                            #energyProviderMob="ngModel"
                            value="{{ energyObjMob.value }}"
                            [(ngModel)]="energyObjMob.checked"
                            (click)="selectthisEnergyProvider(i + 1)"
                          />

                          <label
                          [ngClass]="{'pink-fontcolor' : energyObjMob.checked }"
                            for="energyObj{{ i + 1 }}"
                            style="font-size: 16px; margin-bottom: 0px;cursor: pointer;"
                            class="custom-control-label mt-1"
                          >
                            {{ energyObjMob.value }}</label
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              
                <!-- <div class="col">
                  <h4 style="font-size: 16px">Avg Monthly Usage</h4>
                  <div style="background: #fff; border-radius: 6px">
                    <div
                      *ngFor="let avgUsage of loadAvgUsages; let i = index"
                      class="d-flex align-items-center"
                    >
                      <div
                        class="custom-control custom-checkbox chkbox ml-2 my-0 mb-0"
                        style="margin-bottom: 0px !important"
                      >
                        <input
                          type="checkbox"
                          class="pdfclr custom-control-input"
                          style="margin-right: 7px"
                          id="{{ avgUsage.value }}"
                          (click)="selectAvgChange($event, avgUsage.value)"
                          #avgUsageMob="ngModel"
                          [(ngModel)]="avgUsage.checked"
                          name="{{ avgUsage.value }}"
                          value="{{ avgUsage.value }}"
                        />

                        <label
                          for="{{ avgUsage.value }}"
                          style="font-size: 12px; margin-bottom: 0px"
                          class="custom-control-label mt-1"
                        >
                          {{ avgUsage.key }}</label
                        >
                      </div>
                    </div>
                  </div>
                </div> -->
              </div>
            </div>
          </div>
          <div class="col-10" style="position: relative;">
      <div style="display:none !important" class="container p-0 chartcontainer">
        <div class="chartfixed1" id="chartfixed">
          <div class="container">
            <!-- <div 
              style="
                background: #F0F0F0;
                font-family: 'Calibre-SemiBold';
                font-size: 15px;
                
              "
            >
              <span (click)="showFilterCard()" class="pointer" style="visibility: hidden;"
                >Search Filters</span
              ><mat-icon
                style="position: absolute;visibility: hidden;"
                class="pointer"
                (click)="showFilterCard()"
                >keyboard_arrow_down</mat-icon
              >
              <span
                style="float: right; color: deeppink; margin-right: 5px;visibility: hidden;"
                class="pointer"
                (click)="saveChanges()"
                *ngIf="showFilters"
                >Save Changes</span
              >
            </div>
            <mat-card class="card" *ngIf="showFilters">
              <mat-card-content>
                <div class="row">
                  <div class="col">
                    <h4 style="font-size: 16px">Contract Terms</h4>
                    <div style="background: #e2e2e2; border-radius: 6px">
                      <div
                        class="row no-gutters"
                        *ngFor="let term of dropDownValues; let i = index"
                      >
                        <div>
                          <div class="d-flex align-items-center">
                            <div
                              class="custom-control custom-checkbox chkbox ml-2 my-0 mb-0"
                              style="margin-bottom: 0px !important"
                            >
                              <input
                                type="checkbox"
                                class="pdfclr custom-control-input"
                                style="margin-right: 7px"
                                id="contractTermwb{{ i + 1 }}"
                                name="example{{ i + 1 }}"
                                #terms="ngModel"
                                value="{{ term.value }}"
                                [(ngModel)]="term.checked"
                                (click)="selectthis($event, i + 1, 'Webview')"
                              />

                              <label
                                for="contractTermwb{{ i + 1 }}"
                                *ngIf="term.value !== '1000'"
                                style="font-size: 12px; margin-bottom: 0"
                                class="custom-control-label mt-1"
                              >
                                {{ term.value }}
                              </label>
                              <label
                                for="contractTermwb{{ i + 1 }}"
                                *ngIf="term.value === '1000'"
                                style="font-size: 12px; margin-bottom: 0"
                                class="custom-control-label mt-1"
                              >
                                Show All
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col">
                    <h4 style="font-size: 16px">Energy Providers</h4>
                    <div style="background: #e2e2e2; border-radius: 6px">
                      <div
                        class="row no-gutters"
                        *ngFor="
                          let energyObjMob of energyProviderList;
                          let i = index
                        "
                      >
                        <div>
                          <div
                            class="custom-control custom-checkbox chkbox ml-2 my-0 mb-0"
                            style="margin-bottom: 0px !important"
                          >
                            <input
                              type="checkbox"
                              class="pdfclr custom-control-input  {{ energyObjMob.value == 'Show All' ? 'ShowAllProviderClass' : ''}}"
                              style="margin-right: 7px"
                              id="energyObj{{ i + 1 }}"
                              #energyProviderMob="ngModel"
                              value="{{ energyObjMob.value }}"
                              [(ngModel)]="energyObjMob.checked"
                              (click)="selectthisEnergyProvider(i + 1)"
                            />

                            <label
                              for="energyObj{{ i + 1 }}"
                              style="font-size: 12px; margin-bottom: 0px"
                              class="custom-control-label mt-1"
                            >
                              {{ energyObjMob.value }}</label
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col">
                    <h4 style="font-size: 16px">Product Types</h4>

                    <div style="background: #e2e2e2; border-radius: 6px">
                      <div
                        *ngFor="
                          let productTypes of loadProductTypes;
                          let i = index
                        "
                        class="d-flex align-items-center"
                      >
                        <div
                          class="custom-control custom-checkbox chkbox ml-2 my-0 mb-0"
                          style="margin-bottom: 0px !important"
                        >
                          <input
                            type="checkbox"
                            class="pdfclr custom-control-input"
                            style="margin-right: 7px"
                            id="{{ productTypes.value }}"
                            (click)="productchange($event, productTypes.value)"
                            #productTypesMob="ngModel"
                            [(ngModel)]="productTypes.checked"
                            name="{{ productTypes.value }}"
                            value="{{ productTypes.value }}"
                          />

                          <label
                            for="{{ productTypes.value }}"
                            style="font-size: 12px; margin-bottom: 0px"
                            class="custom-control-label mt-1"
                            >{{ productTypes.key }}</label
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col">
                    <h4 style="font-size: 16px">Avg Monthly Usage</h4>
                    <div style="background: #e2e2e2; border-radius: 6px">
                      <div
                        *ngFor="let avgUsage of loadAvgUsages; let i = index"
                        class="d-flex align-items-center"
                      >
                        <div
                          class="custom-control custom-checkbox chkbox ml-2 my-0 mb-0"
                          style="margin-bottom: 0px !important"
                        >
                          <input
                            type="checkbox"
                            class="pdfclr custom-control-input"
                            style="margin-right: 7px"
                            id="{{ avgUsage.value }}"
                            (click)="selectAvgChange($event, avgUsage.value)"
                            #avgUsageMob="ngModel"
                            [(ngModel)]="avgUsage.checked"
                            name="{{ avgUsage.value }}"
                            value="{{ avgUsage.value }}"
                          />

                          <label
                            for="{{ avgUsage.value }}"
                            style="font-size: 12px; margin-bottom: 0px"
                            class="custom-control-label mt-1"
                          >
                            {{ avgUsage.key }}</label
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div (click)="showFilterCard()">
                  <mat-icon
                    class="pointer"
                    style="
                      position: absolute;
                      padding-left: 520px;
                      color: deeppink;
                    "
                    >keyboard_arrow_up</mat-icon
                  >
                </div>
              </mat-card-content>
              <mat-card-actions> </mat-card-actions>
            </mat-card> -->

            <div class="row d-flex mt-2 mbpadt px-2 chart-container" id="chartbottom">
              
              <div class="col-12 col-sm-12 col-md-6">
                <div
                  class="col-12 col-sm-12 col-md-12 text-center chrt1 mt-3 pl-0 graphBorder"
                >
                  <div
                    *ngIf="recommendationObj && recommendations"
                    class="col-12 text-center horizandalchart pl-0" style="padding-bottom: 40px;"
                  >
                    <div class="d-flex mb-3">
                      <div class="col-1 p-0 term-box text-left ml-1 lnehgt13">
                        Term
                      </div>
                      <div class="ml-2 text-left lnehgt13">
                        Featured Plans - Price (low to high)
                        <i data-toggle="tooltip" title="Click on  any of the plan names below to instantly view its monthly cost in the chart to the right."         class="fa fa-question-circle ml-1"style="
                          vertical-align: bottom !important;
                          cursor: pointer !important;
                        "></i>
                      </div>
                    </div>
                    <div
                      *ngFor="
                        let productObj of preSelectedRecords | slice: 0:5;
                        let i = index
                      "
                      class="d-flex mb-2 handsymbol providersDiv"
                      [style.width]="calculateWidth(productObj)"
                       style="max-width: 530px"
                      [class.active]="
                        recommendations.length != 0 && recommendations[productIndex].ProductID ===
                        productObj.ProductID
                      "
                      id="{{ productObj.ProductID }}"
                    >
                      <div class="col-1 form-control term-box">
                        {{ productObj.terms }}
                      </div>
                      <div
                        class="ml-2 form-control text-left"
                        style="display: flex; align-items: center"
                        (click)="changeIUsageGraphbyProduct(productObj)"
                      >
                        <span
                          class="chrtvalue forallmore"
                          title="{{
                            productObj.energy_provider.toUpperCase() +
                              '-' +
                              productObj.product_key.toUpperCase()
                          }}"
                          >{{
                            productObj.energy_provider.toUpperCase() +
                              '-' +
                              productObj.product_key.toUpperCase()
                          }}</span
                        >
                        <span class="float-right text-nowrap"
                          >{{
                            (
                              productObj.new_tier.ave_price_per_KWH * 100
                            ).toFixed(1)
                          }}<span style="color: #495057">&#162;</span>
                        </span>
                      </div>
                      <div
                        id="sign{{ productObj.ProductID }}"
                        class="ml-2 form-control text-left var-container"
                        style="width: 93px; background: #ed1976"
                        (click)="orderProduct(productObj)"
                      >
                        <div
                          class="w-100"
                          style="
                            padding: 7px 0px;
                            position: relative;
                            background: #ed1976;
                            color: white;
                            font-weight: bold;
                          "
                        >
                          <span
                            style="
                              white-space: nowrap;
                              display: block;
                              position: relative;
                              font-size: 13px !important;
                            "
                            >SIGN UP</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  *ngIf="noproduct || noproductdata"
                  style="color: #ed1976; font-size: 16px !important"
                >
                  <h5>Use different criteria or compare these plans Instead</h5>
                  <p
                    style="
                      font-size: 16px !important;
                      line-height: 12px !important;
                    "
                  >
                    No results found for this search.
                  </p>
                </div>
                <div style="position: absolute;bottom: 0;">
                  <div style="background: #e2e2e2; margin-bottom: 10px">
                    <div
                      class="row align-items-center mt-3"
                      style="line-height: 12px"
                    >

                    <div  *ngIf="hideFreezeopt" class="ml-2" style="padding-left: 15px;">
                      <span *ngIf="!scrollofChart" style="font-size: 16px !important">
                        Freeze chart view</span
                      ><img
                        src="assets/images/toggle-off.svg"
                        class="pl-2"
                        style="
                          font-size: 22px;
                          cursor: pointer;
                          vertical-align: middle;
                          width: 28px !important; height: 15px 
                        "
                        aria-hidden="true"
                        (click)="onfreeze()"
                        *ngIf="!scrollofChart"
                      />
                      <span *ngIf="scrollofChart" style="font-size: 16px !important">
                        Freeze chart view</span
                      ><img
                        src="assets/images/toggle-on.svg"
                        class="pl-2"
                        style="
                          font-size: 22px;
                          cursor: pointer;
                          vertical-align: middle;
                          width: 28px !important; height: 15px 
                        "
                        aria-hidden="true"
                        *ngIf="scrollofChart"
                        (click)="offfreeze()"
                      />
                    </div>
                    
                      <div
                        class="col text-right"
                        style="font-size: 12px; line-height: 6px"
                      >
                        {{ setPaginationDetails(prerecommendation.length) }}
                      </div>
                      <div
                        class="col-auto"
                        style="padding-left: 0px !important"
                      >
                        <mat-icon
                          matTooltip="Previous Records"
                          (click)="previousRecordSet()"
                          class="pointer"
                          >keyboard_arrow_left</mat-icon
                        >
                      </div>
                      <div class="col-auto">
                        <mat-icon (click)="nextRecordSet()" class="pointer"
                          >keyboard_arrow_right</mat-icon
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="col-sm-12 col-md-6 text-center graphBorder chrt2 pr-0"
              >
                <div
                  *ngIf="editoption === true && 1 != 1"
                  class="float-right mr-3 position-relative"
                  (click)="openEditUsage($event)"
                >
                  <i
                    class="fa fa-ellipsis-h handsymbol dot-label"
                    style="font-size: 24px"
                  ></i>
                </div>
                <div
                  *ngIf="editoption === false"
                  class="float-right handsymbol"
                  (click)="resetEditValue('close')"
                >
                  <img src="assets/images/editchart-close.svg" width="12" />
                </div>
            
                <div class="col-12 p-0 float-left mobileTrigger">
                  <!-- <highcharts-chart
                    [Highcharts]="Highcharts"
                    [options]="highChartsOptions"
                    [(update)]="updateValue"
                    [runOutsideAngular]="true"
                    style="width: 100%; height: 305px; display: block;margin-bottom: 20px;"
                  ></highcharts-chart> -->
                </div>
                <div class="col-12 p-0 float-left" style="margin-bottom: 5px;bottom: 0; position: absolute;" >
                  <span
                    class="font-weight-semibold-calibre mob-d-block desk-mr-10"
                    id="billamount"
                    >Avg. Monthly Bill Estimate: ${{
                      graphSelectedProduct
                        ? math.round(
                            graphSelectedProduct.new_tier.ave_monthly_bill
                          )
                        : '-'
                    }}</span
                  >
                  <span
                    class="font-weight-semibold-calibre mob-d-block"
                    id="billamount"
                    >Avg. Price per kWh:
                    {{
                      graphSelectedProduct
                        ? (
                            graphSelectedProduct.new_tier.ave_price_per_KWH *
                            100
                          ).toFixed(1) + '¢'
                        : ''
                    }}</span
                  >
                </div>
              </div>

            
            </div>
          </div>
        </div>
      </div>

      <div class="container m-auto product-list" style=" padding-top:13px">
        <div class="col-sm-12 m-auto p-0" id="productHead0">
       
          <div class="mbpadt" style="float: left">
            <h3 style="display: none;"
              class="recommendfnt"
              id="productHead"
              *ngIf="
                recommendations.length > 1 && allRecommendations.length < 1
              "
            >
              {{ selectHeading }}
            </h3>

            <div
            *ngFor="
                let singleObj of recommendations
                  | slice: 0:visibleCount;
                let i = index
              "
              class="row"
            >

          
           
            <div
              class="plansummary webview othershadw disableborder col-sm-11 CardHeight{{ sanitizeProductID(singleObj.ProductID) }}"
              style="margin: 0px 0px 14px 0px;padding: 0"  
              
              id="singleObj{{ i }}"
              (click)="selectedObject('singleObj' + i, singleObj)"
            >
           
              <div class="d-flex bdrbot align-items-center no-gutters">
                
                <div class="col-12">
                  <table class="plansection">
                    <colgroup>
                    <col width="20%" />
                    <col width="18%" />
                    <col width="28%" />
                    <col width="17%" />
                    <col width="17%" />
                    </colgroup>
                    <tbody>
                      <tr>
                        <td class="wd50 pl-2" style="text-align: center;">

                          <div class="imgDiv">
                            <img src="{{ singleObj.energy_provider_image }}" style="
                            padding-left: 5px;
                            padding-right: 5px;
                            
                            " />
                            </div>
                            <!-- <p class="m-1 font15 font-weight-normal-calibre" id="puctid">
                              PUCT #{{ singleObj.puct }}
                            </p> -->
                            <span style="font-weight: 600; font-family: 'Calibre-SemiBold'">{{
                                  singleObj.product_key
                                }}</span>
                            <div
                              style="
                              background: #F0F0F0;
                              margin-left: 10px;
                              padding: 2px 15px;
                              padding-left: 0px;
                              font-size: 16px;"
                              class="pointer"
                              
                            >
                            <span
                            (click)="
                                showSingleObjFilterCard(singleObj.ProductID);
                                setBaseChargeValue(singleObj)
                              "
                            > {{ open == 'open' && singleObj.ProductID === openIndex ? 'Hide Plan Details' : 'See Plan Details' }}
                              <mat-icon
                                style="position: absolute"
                              
                                >{{ open == 'open' && singleObj.ProductID === openIndex ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</mat-icon>
                              
                                
                              </span>
                            
                            </div>

                        </td>
                        <td class="wd50 pl-2" style="vertical-align: middle;">
                          <div style="padding-left: 20px;">
                            <span style="font-size: 20px; font-family: 'Calibre-Bold'">
                            {{ singleObj.terms }} Months
                            </span>
                            
                             <p style="margin: 0;">
                            {{ singleObj.ProductType }} <img src="assets/images/lock.png" width="8" style="vertical-align: inherit;" />
                             </p>
                            <p *ngIf=" singleObj.energy_provider !== 'Texpo Energy'" > {{ math.round(singleObj.Renewable) }}% Renewable <img src="assets/images/leaf2.png"  width="7" style="vertical-align: inherit;" /></p>
                          </div>
                        </td>
                        <td class="wd50 pl-2">
                          <!-- <div
                            style="font-size: 34px; font-family: 'Calibre-Bold'"
                          >
                            {{
                              (
                                singleObj.new_tier.ave_price_per_KWH * 100
                              ).toFixed(1) + '¢'
                            }}
                          </div> -->
                          <table width="100%" style="text-align:center;
                         
                            background: #F0F0F0;font-size: 16px;
                          ">
                            <tbody>
                              <tr>
                                <th>500 kWh</th>
                                <th>1000 kWh</th>
                                <th>2000 kWh</th>
                              </tr>
                              <tr style="line-height: 0.5;">
                                <td style="padding: 0px !important;">{{(singleObj.tier[0].avg_charge * 100).toFixed(1)}}¢</td>
                                <td style="padding: 0px !important;">{{(singleObj.tier[1].avg_charge * 100).toFixed(1)}}¢</td>
                                <td style="padding: 0px !important;">{{(singleObj.tier[2].avg_charge * 100).toFixed(1)}}¢</td>
                              </tr>
                            </tbody>
                          </table>

                          <highcharts-chart
                          [Highcharts]="Highcharts"
                          [options]="{
                            chart: { type: 'line', backgroundColor: 'transparent'}, 
                            xAxis: {
                              visible: false
                            },
                            yAxis: {
                              visible: false
                            },
                            legend: {
                              enabled: false
                            },
                            credits: {
                              enabled: false
                            },
                            tooltip: {
                              pointFormat: '{point.y}¢',
                              headerFormat: '',
                              footerFormat: ''
                            },
                            title: { text: ''},
                            series: [{ data: [+(singleObj.tier[0].avg_charge * 100).toFixed(1),
                                              +(singleObj.tier[1].avg_charge * 100).toFixed(1),
                                              +(singleObj.tier[2].avg_charge * 100).toFixed(1)
                                            ],
                                    color: 'black' }]
                            
                          }"
                          [runOutsideAngular]="true"
                          style="max-width: 240px !important; height: 60px !important; display: block !important;
                              padding-left: 10px !important;
                              background: #F0F0F0 !important;
                              padding-right: 10px ;
                              padding-top:10px
                          "
                        ></highcharts-chart>
                        
                       
                        </td>
                        <td class="wd50 pl-2" style="text-align: center;">
                          <div *ngIf="ShowUpdatedUsage" style="text-align: left;">

                              <p style="margin-top: 10px;margin-bottom: 0;font-family: 'Calibre-Bold'; font-size: 18px;">
                              ${{
                                  singleObj.new_tier.ave_monthly_bill
                                }}
                                 <span style="font-family: 'Calibre'"> Avg Bill*</span>
                              </p>
                              <p style="margin-bottom: 0;font-family: 'Calibre-Bold'; font-size: 18px;">
                                ${{getMaxMonth(singleObj.monthly_usage).total_energy_charge_per_month}} 
                              
                                <span style="font-family: 'Calibre'; font-size: 15px;">High ({{getMonthShortCode(getMaxMonth(singleObj.monthly_usage).month)}})</span>
                              </p> 
                              <p style="margin-bottom: 0;font-family: 'Calibre-Bold'; font-size: 18px; line-height: 1;">
                                ${{getMinMonth(singleObj.monthly_usage).total_energy_charge_per_month}} 
                                
                                <span style="font-family: 'Calibre'; font-size: 15px;">Low ({{getMonthShortCode(getMinMonth(singleObj.monthly_usage).month)}})</span>
                              </p> 


                          </div>
                          <div *ngIf="!ShowUpdatedUsage">

                              <div
                                style="font-size: 34px; font-family: 'Calibre-Bold'"
                              >
                                ${{
                                  math.round(singleObj.new_tier.ave_monthly_bill)
                                }}
                              </div>
                              <p style="margin-top: 10px;margin-bottom: 0;">
                              Monthly Bill Estimate
                              </p>
                              <p style="line-height: 1;">
                                for
                                {{
                                  math.round(singleObj.new_tier.ave_monthly_usage)
                                }}
                                kWh avg usage*
                              </p>


                          </div>
                        
                        </td>
                       
                        <td  style="text-align: center; padding-left: 0px !important;" class="wd50 wrdbrk pl-2">
                          <p
                            class="fwgtsix"
                            style="
                              font-size: 50px;
                              font-family: 'Calibre-Bold';
                              color: deeppink;
                              line-height: 29px;
                            "
                          >
                            {{
                              (
                                singleObj.new_tier.ave_price_per_KWH * 100
                              ).toFixed(1) + '¢'
                            }}
                          </p>
                          <p style="margin-top: 5px">
                            Avg Price per {{ singleObj.energy_units }}*
                          </p>
                          <div *ngIf="ShowUpdatedUsage">
                          <p style="line-height: 0.5;">
                            Base on usage history
                          </p>
                          </div>
                          <div *ngIf="!ShowUpdatedUsage">

                            <p style="line-height: 0.5;">
                            (${{
                              math.round(singleObj.new_tier.ave_monthly_bill)
                            }}
                            <span>&#247; </span
                            >{{
                              math.round(singleObj.new_tier.ave_monthly_usage)
                            }}kWh)
                          </p>

                          </div>
                          
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <!-- <div class="plan webview align-items-center" style="padding-bottom: 13px;">
                    <div class="plandesc col">
                     
                    </div>
                    <div (click)="orderProduct(singleObj)" style=" cursor: pointer;" class="col col-auto webview text-center">
                      <a
                        class="btn signup font18 font-weight-bold-calibre sectbtnhvr"
                       
                        >Buy Now</a
                      ><br />
                    </div>
                  </div> -->
                </div>
              </div>
              <div
                class="webview"
                *ngIf="
                  open == 'open' && singleObj.ProductID === openIndex
                "
              >
                <div
                  style="
                    background: #e2e2e2;
                    font-family: 'Calibre-SemiBold';
                    font-size: 15px;
                    margin-top: 10px;
                    padding-left: 10px;
                  "
                >
                  Plan Details
                </div>
                <div class="d-flex">
                  <div class="col-3" style="max-width: 10% !important; font-size: 13px !important;text-decoration: underline;">
                    <div class="d-flex">
                      <div class="">
                        <img src="assets/images/pdf.svg" width="18" />
                      </div>
                      <div>
                        <a
                          class="pt-1 pl-1"
                          style="color: #2b2e34 !important"
                          href="{{ singleObj.productEFL }}"
                          target="_blank"
                          >EFL</a
                        >
                      </div>
                    </div>
                    <div class="d-flex">
                      <div class="float-left">
                        <img src="assets/images/pdf.svg" width="18" />
                      </div>
                      <div>
                        <a
                          class="pt-1 pl-1"
                          style="color: #2b2e34 !important"
                          href="{{ singleObj.productTOS }}"
                          target="_blank"
                          >TOS</a
                        >
                      </div>
                    </div>
                    <div class="d-flex">
                      <div class="float-left">
                        <img src="assets/images/pdf.svg" width="18" />
                      </div>
                      <div>
                        <a
                          class="pt-1 pl-1"
                          style="color: #2b2e34 !important"
                          href="{{ singleObj.productYRAC }}"
                          target="_blank"
                          >YRAC</a
                        >
                      </div>
                    </div>
                  </div>
                  <div class="col-9">
                    <div class="pb-2" style="line-height: 15px">
                      <div style="padding-left: 0px; padding-top: 5px; font-family: 'Calibre-Bold'" class="plandesc col pb-2">
                        <span style="font-weight: 600">{{
                          singleObj.product_key 
                        }}</span>
                        <span
                          class="font-weight-normal-calibre text-left"
                          [innerHTML]="'<br />' + singleObj.description"
                        ></span>
                      </div>
                      <span
                        style="font-family: 'Calibre-SemiBold'" 
                        >Early Cancellation</span
                      ><br />
                      <span>
                        {{ setCancellationText(singleObj.cancellation_fee) }}
                      </span>
                    </div>
                    <div class="">
                      <span
                        style="font-family: 'Calibre-SemiBold'"
                        >Pricing Details</span
                      >
                      <div>
                        <table class="plantbl text-center">
                          <thead>
                            <th class="fwgtthree" width="28%">Monthly Usage</th>
                            <th
                              *ngFor="let usageObj of singleObj.tier"
                              class="tabpad brdrgtblk font-weight-normal-calibre fwgtthree"
                            >
                              {{ usageObj.usage }} kWh
                            </th>
                            <th
                              class="radius2 last-th font-weight-bold-calibre"
                            >
                              <span class=""></span>{{
                                math.round(singleObj.new_tier.ave_monthly_usage)
                              }} kWh
                            </th>
                          </thead>
                          <tbody>
                            <td
                              class="tabpadd radius4 brdrgtblk semi-bold font-weight-normal-calibre"
                              style="background-color: #e2e2e2 !important"
                            >
                              Average Price per kWh
                            </td>
                            <td
                              *ngFor="let usageObj of singleObj.tier"
                              class="tabpadd brdrgtblk semi-bold font-weight-normal-calibre"
                            >
                              {{ (usageObj.avg_charge * 100).toFixed(1)
                              }}<span>&#162;</span>
                            </td>
                            <td
                              class="tabpadd radius3 last-th pdfclr semi-bold "
                            >
                              {{
                                singleObj
                                  ? (
                                      singleObj.new_tier.ave_price_per_KWH * 100
                                    ).toFixed(1)
                                  : '-'
                              }}¢<font class="fwgtthree">Your Avg&#42;</font>
                            </td>
                          </tbody>
                        </table>
                      </div>
                      <div class="mt-2">
                        <div style="line-height: 1 !important; padding: 0px !important; margin: 0px !important ; " >
                        <span style="font-family: 'Calibre-SemiBold'"
                          >How Your Bill is Calculated for {{ math.round(singleObj.new_tier.ave_monthly_usage) }} kWh Usage</span
                        >
                        <p *ngIf=" singleObj.energy_provider !== '4Change Energy' && singleObj.energy_provider !== 'Rhythm Energy' && singleObj.energy_provider !== 'APGE Energy' && singleObj.energy_provider !== 'Pulse Power' && singleObj.energy_provider !== 'New Power Texas' && singleObj.energy_provider !== 'Shell Energy'" class="WordSpace  mb-0">
                          Energy Charge:
                          {{ setValidatedValue(singleObj.energy_charge) }} per
                          kWh
                        </p>
                        <p *ngIf=" singleObj.energy_provider == '4Change Energy'" class="WordSpace mb-0">
                          Energy Charge:
                          {{ setValidatedValue_4Change(singleObj.energy_charge) }} per
                          kWh
                        </p>
                        <p *ngIf="(singleObj.energy_provider == 'Pulse Power' || singleObj.energy_provider == 'New Power Texas' || singleObj.energy_provider == 'Shell Energy')  && singleObj.ProductType != 'TimeOfUse'" class="WordSpace mb-0">
                          Energy Charge:
                          {{ setValidatedValue_Pulse(singleObj.energy_charge) }} per
                          kWh
                        </p>

                        <div *ngIf=" (singleObj.energy_provider == 'Pulse Power' || singleObj.energy_provider == 'New Power Texas')  && singleObj.ProductType == 'TimeOfUse'">

                          <p  class="WordSpace mb-0">
                            Daytime Energy Charge: {{ setValidatedValue_Pulse(singleObj.energy_charge) }}
                          </p>
                          <p  class="WordSpace mb-0">
                            Daytime Energy Factor: 60% 
                          </p>
                          <p  class="WordSpace mb-0">
                            Nighttime Energy Charge: FREE
                          </p>
                          <p  class="WordSpace mb-0">
                            Nighttime Energy Factor: 40% 
                          </p>
                        </div>
                    

                        <p *ngIf=" singleObj.energy_provider == 'Rhythm Energy' || singleObj.energy_provider == 'APGE Energy'" class="WordSpace mb-0">
                          Energy Charge:
                          {{ setValidatedValue_Rhythm(singleObj.energy_charge) }} per
                          kWh
                        </p>

                        <p
                          *ngIf=" singleObj.base_fee != null &&
                            singleObj.energy_provider === '4Change Energy'
                            
                          "
                          class="WordSpace mb-0"
                        >
                          Base Charge:
                          ${{ singleObj.base_fee }} 
                          per billing cycle
                        </p>
                        <p
                          *ngIf="
                            singleObj.base_fee != null &&
                            singleObj.energy_provider !== '4Change Energy'
                          "
                          class="WordSpace mb-0"
                        >
                          Base Charge:
                          {{ SetBaseChargeValidatedValue(singleObj.base_fee) }}
                          per billing cycle
                        </p>
                        <p
                          *ngIf="
                            (singleObj.usage1 != null ||
                              singleObj.usage2 != null) &&
                            (singleObj.energy_provider === 'Gexa Energy' ||
                              singleObj.energy_provider ===
                                'Frontier Utilities')
                          "
                          class="WordSpace mb-0"
                        >
                          Usage Credit: {{ usage4CEObj.usageValue }}
                        </p>
                        <p
                          *ngIf="
                            (singleObj.usage3 != null ||
                              singleObj.usage4 != null) &&
                            (singleObj.energy_provider === 'Gexa Energy' ||
                              singleObj.energy_provider ===
                                'Frontier Utilities')
                          "
                          class="WordSpace mb-0"
                        >
                          Usage Credit: {{ usage4CEObj.addUsageValue }}
                        </p>
                        <p
                          class="WordSpace mb-0"
                          *ngIf="
                            (
                            singleObj.energy_provider === 'New Power Texas') && singleObj.minEnergyUsage !== 0 && singleObj.billCredit != undefined && singleObj.billCredit !== 0
                          "
                        >
                        Usage Credit:
                        {{ removeminus(singleObj.billCredit) }} per billing cycle of atleast {{ singleObj.minEnergyUsage }} kWh
                        </p>

                          <p
                          class="WordSpace mb-0"
                          *ngIf="
                            (
                            singleObj.energy_provider === 'Chariot Energy') && singleObj.billCredit !== '0' &&  singleObj.billCreditTrigger !== '0'
                          "
                        >
                        Usage Credit:
                        {{ removeminus(singleObj.billCredit) }} per billing cycle of atleast {{ singleObj.billCreditTrigger }} kWh
                        </p>

                        <p
                          class="WordSpace mb-0"
                          *ngIf="singleObj.energy_provider === '4Change Energy'"
                        >
                          Bill Credit:
                          {{ removeminus(singleObj.billCredit) }} per billing cycle of atleast {{ singleObj.usageTrigger }} kWh

                        </p>
                        <p
                          class="WordSpace mb-0"
                          *ngIf="singleObj.energy_provider === 'Texpo Energy'"
                        >
                          Minimum Usage Fee:
                          ${{ singleObj.minEnergyCharge }} (for usage less than {{ singleObj.minEnergyUsage }} kWh)

                        </p>
                        <p
                        class="WordSpace mb-0"
                        *ngIf="singleObj.energy_provider === 'Shell Energy'  && singleObj.minEnergyCharge != 0 "
                      >
                        Minimum Usage Fee:
                        ${{ singleObj.minEnergyCharge }} (all usage below {{ singleObj.minEnergyUsage }} kWh)

                      </p>
                      <p
                        class="WordSpace mb-0"
                        *ngIf="singleObj.energy_provider === 'Shell Energy'  && singleObj.ProductType.indexOf('Buyback') > -1 "
                      >
                        Solar Buyback Rate: Real-Time Market Rate

                      </p>
                        <div
                        *ngIf="
                        singleObj.energy_provider != 'Pulse Power' && singleObj.energy_provider != 'New Power Texas'
                        
                        "
                        >
                        <p class="WordSpace mb-0">
                          TDU Delivery Charge:
                          {{ setValidatedValue(singleObj.tdu_delivery_charge) }}
                          per billing cycle
                        </p>
                        <p class="WordSpace mb-0">
                          TDU Delivery Charge:
                          {{
                            setValidatedTDUValue(
                              singleObj.tdu_delivery_charge_per_kwh
                            )
                          }}
                          per kWh
                        </p>
                      </div>

                      <div
                      *ngIf="
                        (singleObj.energy_provider == 'Pulse Power' || singleObj.energy_provider == 'New Power Texas') && singleObj.ProductType == 'TimeOfUse'
                      
                      "
                      >
                      <p class="WordSpace mb-0">
                        TDU Delivery Charge:
                        {{ setValidatedValue(singleObj.tdu_delivery_charge) }}
                        per billing cycle
                      </p>
                      <p class="WordSpace mb-0">
                        TDU Delivery Charge:
                        {{
                          setValidatedTDUValue(
                            singleObj.tdu_delivery_charge_per_kwh
                          )
                        }}
                        per kWh
                      </p>
                    </div>

                    <div
                      *ngIf="
                        (singleObj.energy_provider == 'Pulse Power' || singleObj.energy_provider == 'New Power Texas') && singleObj.ProductType != 'TimeOfUse' 
                      
                      "
                      >
                      <!-- <p class="WordSpace">
                        TDU Delivery Charge:
                        Bundled / Included
                        per billing cycle
                      </p>
                      <p class="WordSpace">
                        TDU Delivery Charge:
                        Bundled / Included
                        per kWh
                      </p> -->
                      <p class="WordSpace mb-0">
                        TDU Delivery Charge:
                        {{ setValidatedValue(singleObj.tdu_delivery_charge) }}
                        per billing cycle
                      </p>
                      <p class="WordSpace mb-0">
                        TDU Delivery Charge:
                        {{
                          setValidatedTDUValue(
                            singleObj.tdu_delivery_charge_per_kwh
                          )
                        }}
                        per kWh
                      </p>
                    </div>

                        <p class="WordSpace mb-0"
                        *ngIf="
                        (singleObj.energy_provider === 'Chariot Energy' ||
                        singleObj.energy_provider === 'APGE Energy')
                        "
                        >
                        {{ singleObj.energy_provider === 'Chariot Energy' ? "Ercot Securitization Charge" : "Securitization Charge" }}: ${{singleObj.SecuritizationCharge}} per kWh
                         
                        </p>

                        <p *ngIf="singleObj.energy_provider != 'Pulse Power' && singleObj.energy_provider != 'New Power Texas'"  class="WordSpace mb-0">
                          *Avg. Price per kWh = ({{
                            singleObj.energy_provider
                          }} Energy Charges {{ singleObj.energy_provider === 'APGE Energy' ? "+ Base Charge " :"" }}+
                           TDU Charges {{singleObj.energy_provider === 'Chariot Energy' || singleObj.energy_provider === 'APGE Energy' ? singleObj.SecuritizationChargeLabel : ""}} ) / Total Monthly Usage
                        </p>

                        <p *ngIf="(singleObj.energy_provider === 'Pulse Power' || singleObj.energy_provider == 'New Power Texas')&& singleObj.ProductType != 'TimeOfUse'"  class="WordSpace mb-0">
                          *Avg Price per kWh = (Energy Charge x Total Monthly Usage) + Base Charge
                        </p>
                        <p *ngIf="(singleObj.energy_provider === 'Pulse Power' || singleObj.energy_provider == 'New Power Texas') && singleObj.ProductType == 'TimeOfUse'"  class="WordSpace mb-0">
                          *Price per kWh = [TDU Delivery Charges per Month + (Monthly billed kWh Usage x (Energy Rate + TDU Delivery Charges per kWh)) - (Energy Rate x applicable Free Charging kWh Usage)]/Monthly Billed kWh Usage.
                        </p>
                        
                      </div>
                        <div
                        class="fwgtsix pt-3 pb-3"
                        style="
                          font-size: 16px;
                          font-weight: bolder;
                          text-decoration: underline;
                          cursor: pointer;
                          max-width: 235px;
                        "
                        (click)="changeIUsageGraphbyProduct(singleObj,true)"
                      >
                        {{  ShowChart && ChartProductId == singleObj.ProductID ? 'Hide Estimated Bill & Usage Chart' : 'See Estimated Bill & Usage Chart' }}
                        <mat-icon
                        style="position: absolute;line-height: inherit;cursor: pointer;"
                        class="pointer"
                      
                        >{{  ShowChart && ChartProductId == singleObj.ProductID ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</mat-icon>
                      </div>
  
                       
                        <highcharts-chart *ngIf="ShowChart && ChartProductId == singleObj.ProductID"
                        [Highcharts]="Highcharts"
                        [options]="highChartsOptions"
                        [(update)]="updateValue"
                        [runOutsideAngular]="true"
                        style="width: 650px; height: 305px; display: block;margin-bottom: 20px;"
                      ></highcharts-chart>


                      <div *ngIf="ShowChart && ChartProductId == singleObj.ProductID"  style=" cursor: pointer;" class="col col-auto webview text-center">
                        <a
                          class="btn signup font18 font-weight-bold-calibre sectbtnhvr"
                          (click)="orderProduct(singleObj)"
                          >Buy Now</a
                        ><br />
                        <i   (click)="showSingleObjFilterCard(singleObj.ProductID);" aria-hidden="true" class="fa fa-angle-up font33 pdfclr2 mt-3"></i>
                      </div>


                      </div>
                      
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-1 px-0 BuyNowParentDiv webview">

              

              <div  *ngIf="open == 'open' && singleObj.ProductID === openIndex" [ngStyle]="{ height: PlanCardheight }" class="BuyNowButton"  (click)="orderProduct(singleObj)">
                  Buy <br/> Now
              </div>

              
              <div  *ngIf="open != 'open' || singleObj.ProductID !== openIndex" class="BuyNowButton"  (click)="orderProduct(singleObj)">
                  Buy <br/> Now
              </div>


            </div>
            
            </div>
            <div class="SeeMoreDiv" *ngIf="visibleCount < recommendations.length" ><h5 (click)="loadMore()">See more plans</h5></div>
            <br />
            <div
              class="col-sm-10 col-md-8 p-0 pb-5 col-lg-8 text-left m-auto font-weight-normal-calibre avgdetl"
            >
              <span
                >*The estimates provided here and throughout the website have
                been calculated to include all of the recurring charges that you
                will normally see on your bill, excluding government fees and
                taxes. All numbers presented are estimates based on information
                provided by you and each energy company. These estimates should
                be confirmed using the information found in the Electricity
                Facts Label and Terms of Service. Please note, your Average
                Price per kWh and Average Monthly Bill Estimate will vary each
                month according to your actual usage, as illustrated in the bar
                chart above.</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
    </div>
    </div>
  </main>
</div>

<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff">
  <img src="assets/images/loading.gif" />
</ngx-spinner>

<div class="backdrop" [ngStyle]="{ display: display }"></div>
<div class="modal" tabindex="-1" role="dialog" [ngStyle]="{ display: display }">
  <div class="modal-dialog" role="document">
    <div class="modal-content m-auto blockbg boxclr text-center">
      <div class="modal-body">
        <div class="">
          <img src="assets/images/loading.gif" />
          <p class="text-center tipmes font16 webview">
            Did you know that gorillas and monkeys actually don’t eat
            <br />bananas in the wild?
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="backdrop webview" [ngStyle]="{ display: display1 }"></div>
<div
  class="modal"
  tabindex="-1"
  role="dialog"
  [ngStyle]="{ display: display1 }"
>
  <div class="modal-dialog" role="document">
    <div class="modal-content m-auto blockbg boxclr text-center">
      <div class="modal-body">
        <div class="">
          <img src="assets/images/loading.gif" />
          <p class="text-center tipmes font15">
            Please wait for a few seconds...
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #newEnergyRates>
  <div id="serviceunavialbe">
    <div class="modal-header pr-1 pt-1">
      <div class="col-12 text-right py-0 px-0">
        <button
          type="button"
          class="close pull-right borderNone closeModelAlign"
          aria-label="Close"
          (click)="newEnergyProviderRates()"
        >
          <div _ngcontent-c5="" class="float-right mr-1 mt-1">
            <img src="assets/images/editchart-close.svg" width="17" />
          </div>
        </button>
      </div>
    </div>
    <div class="modal-body pt-0">
      <h4 class="utility-modal-title font20 text-center text-uppercase">
        THESE OFFERS HAVE EXPIRED
      </h4>
      <p class="utility-sub-title font20">
        PRICE FLASH! Due to market volatility, this price is no longer being
        offered by the energy provider you have selected. However, this update
        could possibly work in your favor!
      </p>
      <br />
      <p class="utility-sub-title font20">
        Click the button below 👇 to see new rates.
      </p>
      <br />
      <p class="utility-sub-title font20">
        We appreciate your patience, and apologize In advance for any
        inconvenience, while we update our records. This may take a few seconds.
      </p>
      <div class="col-12 text-center">
        <button
          class="btn mr-2 ml-2 col-12 font-weight-bold-calibre contbtn text-uppercase mb-3"
          (click)="newEnergyProviderRates()"
        >
          see new rates
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #noofferPopup>
  <div id="serviceunavialbe">
    <div class="modal-header pr-1 pt-1">
      <div class="col-12 text-right py-0 px-0">
        <a
         
          class="close pull-right borderNone closeModelAlign"
          aria-label="Close"
          href="{{this.app_url}}" target="_parent"
        >
          <div _ngcontent-c5="" class="float-right mr-1 mt-1">
            <img src="assets/images/editchart-close.svg" width="17" />
          </div>
        </a>
      </div>
    </div>
    <div class="modal-body pt-0">
      <h4 class="utility-modal-title font20 text-center text-uppercase">
        
        Products comming soon.
      </h4>

      <!-- <p class="utility-sub-title font20">
       Products comming soon.
      </p> -->
      <div class="row">
        <!-- <p class="utility-sub-title font20">
       Products comming soon.
      </p> -->
      <div class="col-3 text-center">
      
      </div>
      <div class="col-6 text-center">
        <a
          class="btn mr-2 ml-2 col-12 font-weight-bold-calibre contbtn text-uppercase mb-3"
          href="{{this.app_url}}" target="_parent"
        >
          OK
      </a>
      </div>
      <div class="col-3 text-center">
      
      </div>
    </div>
    </div>
  </div>
</ng-template>

<ng-template #earlyCancellationPopup>
  <div id="earlyCancellation">
    <div class="modal-header pr-1 pt-1">
      <div class="col-12 text-right py-0 px-0">
        <button
          type="button"
          class="close pull-right borderNone closeModelAlign"
          aria-label="Close"
          (click)="closePopupModel()"
        >
          <div _ngcontent-c5="" class="float-right mr-1 mt-1">
            <img src="assets/images/editchart-close.svg" width="17" />
          </div>
        </button>
      </div>
    </div>
    <div class="modal-body pt-0">
      <h4 class="utility-modal-title font20 text-center text-uppercase">
        EARLY CANCELLATION FEE
      </h4>
      <p class="utility-sub-title font20">
        This fee will not apply if you move and provide a forwarding address and
        other evidence verifying the move.
      </p>
    </div>
  </div>
</ng-template>

<ng-template #planDetailsPopup>
  <div id="planDetails" class="webview">
    <div class="modal-header pr-1 pt-1">
      <div class="col-12 text-right py-0 px-0">
        <button
          type="button"
          class="close pull-right borderNone closeModelAlign"
          aria-label="Close"
          (click)="closePopupModel()"
        >
          <div _ngcontent-c5="" class="float-right mr-1 mt-1">
            <img src="assets/images/editchart-close.svg" width="17" />
          </div>
        </button>
      </div>
    </div>
    <div class="modal-body pt-0">
      <h4 class="utility-modal-title font20 text-center text-uppercase">
        {{ productKeyTitle }}
      </h4>
      <div class="rounded">
        <div>
          <table class="table">
            <thead>
              <tr style="background: #e2e2e2">
                <th scope="col" class="font15 semi-bold text-center">
                  Monthly Usage
                </th>
                <th scope="col" class="font15 semi-bold text-center">
                  Average Price Per kWh
                </th>
                <th scope="col" class="font15 semi-bold text-center">
                  Monthly Estimate
                </th>
              </tr>
            </thead>
            <tbody
              style="font-size: 15px; font-family: Calibre; text-align: center"
            >
              <tr>
                <td>500 kWh</td>
                <td>{{ avgCharge500 }}¢</td>
                <td>${{ monthlyEstimates[0] }}</td>
              </tr>
              <tr>
                <td>1000 kWh</td>
                <td>{{ avgCharge1000 }}¢</td>
                <td>${{ monthlyEstimates[1] }}</td>
              </tr>
              <tr>
                <td>2000 kWh</td>
                <td>{{ avgCharge2000 }}¢</td>
                <td>${{ monthlyEstimates[2] }}</td>
              </tr>
              <tr>
                <td style="background: deeppink; color: white">
                  {{ averageMonthlyUsage }} kWh
                </td>
                <td style="color: deeppink">{{ avgPricePerKWH }}¢</td>
                <td style="color: deeppink">${{ avgMonthlyBill }}</td>
              </tr>
              <tr>
                <td
                  style="
                    font-size: 13px !important;
                    padding: 0.05rem !important;
                  "
                >
                  Your Avg*
                </td>
                <td></td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </div>
        <div style="padding-bottom: 15px">
          <p style="font-size: 20px; font-weight: 600">
            Here is how the plan charges above are calculated:
          </p>
        </div>
        <div style="font-size: 16px; font-family: Calibre">
          <p>
            <span style="font-family: 500">Energy Charge</span>:
            {{ recommendedEnergyCharge }}¢ per kWh
          </p>
          <p *ngIf="recommendedBaseFee !== 0">
            <span style="font-family: 500">Base Charge</span>: ${{
              recommendedBaseFee
            }}
            per billing cycle for usage {{ recommendedBaseUsageLimit }} kWh
          </p>
          <p *ngIf="recommendedUsageCreditFee !== 0">
            <span style="font-family: 500"> Usage Credit</span>: ${{
              recommendedUsageCreditFee
            }}
            per billing cycle for usage {{ recommendedUsageCreditLimit }} kWh
          </p>
          <p>
            <span style="font-family: 500">TDU Delivery Charge:</span>: ${{
              recommendedTduCharge
            }}
          </p>
          <p>
            <span style="font-family: 500">TDU Delivery Charge</span>: ${{
              recommendedTduDeliveryCharge
            }}
            per kWh
          </p>
        </div>
        <div style="font-size: 12px; font-family: Calibre">
          *Avg. Price per kWh = ({{ productTitle }} charges + TDU Charges) /
          Total Monthly Usage
        </div>
      </div>
    </div>
  </div>
</ng-template>
<!-- New Compare Product UI for mobile version -->
<div class="mobileview">
  <app-product-comparison *ngIf="Ismobileview"></app-product-comparison>
</div>
